import React from 'react'
import LayoutComponent from '../BaseScreen'

const SettingsScreen = () => {
  return (
    <LayoutComponent
      header={null} // Render your custom header component here
      content={<div>Settings</div>} // Render your custom content component here
    />
  )
}

export default SettingsScreen
